import { trimChar } from '../../common';
import { IManualKustoDataSource } from '../../core/domain';

export function dataSourcesEqual(a: Omit<IManualKustoDataSource, 'id'>, b: Omit<IManualKustoDataSource, 'id'>) {
    return (
        a.database === b.database && a.kind === b.kind && trimChar(a.clusterUri, '/') === trimChar(b.clusterUri, '/')
    );
}
